import Vue from 'vue';
import Vuex from 'vuex';
import {
    INIT_ENV,
    QUERY_RESULT,
    COUPON_LIST,
    PARK_DETAIL,
    USER_AGENT,
    USABLE_COUPON,
    USABLE_REBATE,
    PICK_COUPON,
    SET_COUNTDOWN,
    LIMIT_PARK,
    DISABLED_ADVERT_PARKS,
    ADVERT_EXIT_PARK,
    USER_IS_OPEN_PAY_NO_PASSWORD,
} from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 服务环境
        appEnv: 'test',
        // 客户端
        userAgent: '',
        // 车费数据
        queryResult: {},
        // 用户所有优惠券
        coupon: [],
        // 可用线下券
        usableCoupon: [],
        // 可用线上券
        usableRebate: [],
        // 当前车场数据
        park: {},
        // 已选优惠券 { data: 券数据, type: 券类型 }
        pickupCoupon: {},
        // 支付倒计时
        payCountdown: 60,
        // 限定车场名
        limitPark: '',
        // 广告禁投车场名单（null=未加载完成；空数组=无禁投；-1=全部车场隐藏）
        disabledAdvertParks: null as number[] | null,
        // 出口码解析出的车场ID（plate=rryb-* 流量，非出口码为 null）
        advertExitPark: null as number | null,
        // 用户开通免密支付
        isOpenPayNoPassword: false,
    },

    getters: {
        /**
         * 广告是否隐藏（车场维度：出口码解析或查询结果的 park_id 任一命中名单即隐藏）
         * 名单未加载完成期间：出口码流量先隐藏（宁可不投不错投），其余流量照常显示；
         * 名单加载完成（含失败兜底空数组）后按 -1/车场ID 精确判断
         * @author logic
         * @date 2026-10-09
         */
        advertHidden(state): boolean {
            const parks = state.disabledAdvertParks;
            if (parks === null) {
                return state.advertExitPark !== null;
            }
            if (parks.includes(-1)) {
                return true;
            }
            // 查询结果的 park_id 为权威值（出口码解析仅用于查询前的提前判断）
            const queryResult: any = state.queryResult;
            const parkId = (queryResult && queryResult.park_id) || state.advertExitPark;
            return parkId ? parks.includes(+parkId) : false;
        },
    },

    mutations: {
        [INIT_ENV](state, value) {
            state.appEnv = value;
        },

        [QUERY_RESULT](state, value) {
            state.queryResult = value;
        },

        [COUPON_LIST](state, value) {
            state.coupon = value.concat();
        },

        [PARK_DETAIL](state, value) {
            state.park = value;
        },

        [USER_AGENT](state, value) {
            state.userAgent = value;
        },

        [USABLE_COUPON](state, value) {
            state.usableCoupon = value.concat();
        },

        [USABLE_REBATE](state, value) {
            state.usableRebate = value.concat();
        },

        [PICK_COUPON](state, value) {
            state.pickupCoupon = Object.assign({}, value);
        },

        [SET_COUNTDOWN](state, value) {
            state.payCountdown = value;
        },

        [LIMIT_PARK](state, value) {
            state.limitPark = value;
        },

        [DISABLED_ADVERT_PARKS](state, value) {
            state.disabledAdvertParks = Array.isArray(value) ? value : [];
        },

        [ADVERT_EXIT_PARK](state, value) {
            state.advertExitPark = typeof value === 'number' ? value : null;
        },

        [USER_IS_OPEN_PAY_NO_PASSWORD](state, value) {
            state.isOpenPayNoPassword = value;
        },
    },
});
